import { useUser } from '@40seas/frontend/libs/hooks';
import { useDataProvider } from 'react-admin';
import DefaultDataProvider from '../providers/defaultDataProvider';

export const useHubspot = () => {
    const user = useUser();
    const dataProvider = useDataProvider() as DefaultDataProvider;

    const createVisitorIdentificationToken = async () => {
        const {
            data: { token },
        } = await dataProvider.customGet('hubspot', 'visitor-identification/token');

        return token;
    };

    return { user, createVisitorIdentificationToken };
};
